import * as actionTypes from '../types/authentication.js'

const initialState = {
  membersArea: false,
}

const authentication = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SHOW_MEMBERS_AREA_PAGE:
      return {
        ...state,
        membersArea: action.payload,
      }
    default:
      return { ...state }
  }
}

export default authentication
